import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/help/$")({
  beforeLoad: ({ params }) => {
    // 301 permanent redirect to new docs location, preserving the slug
    const slug = params._splat || ""
    throw redirect({
      to: slug ? "/docs/$lang/$" : "/docs/$lang",
      params: { lang: "en", _splat: slug },
      replace: true,
    })
  },
})
